"use client"
import dynamic from "next/dynamic"

export * from "./ReactVideoPlayer.mockProps"
export * from "./ReactVideoPlayer"

const ReactVideoPlayerNoSSR = dynamic(
  () => import("./ReactVideoPlayer").then((mod) => mod.ReactVideoPlayer),
  { ssr: false },
)

export { ReactVideoPlayerNoSSR }
